import { LinearProgress, Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import React, { FC } from 'react'

import { useStyles } from './BulkActivateDeactivateDialog.styles'

const SAVING_CHANGES_LABEL = 'Saving changes'

type ProgressContentProps = {
    progressPercentage: number
}

export const ProgressContent: FC<ProgressContentProps> = ({ progressPercentage }) => {
    const classes = useStyles()
    return (
        <>
            <Typography variant="body2" aria-live="polite" aria-atomic="true">
                {SAVING_CHANGES_LABEL}
            </Typography>
            <div className={classes.progressContainer}>
                <LinearProgress
                    variant="determinate"
                    value={progressPercentage}
                    aria-label={SAVING_CHANGES_LABEL}
                    className={classes.progressBar}
                />
            </div>
        </>
    )
}

type ProgressActionsProps = {
    isActivate: boolean
}

export const ProgressActions: FC<ProgressActionsProps> = ({ isActivate }) => {
    const progressLabel = isActivate ? 'Activating…' : 'Deactivating…'
    return (
        <Button disabled variant="contained" color={isActivate ? 'primary' : 'secondary'}>
            {progressLabel}
        </Button>
    )
}
